import { useEffect, useState } from 'react';

import {
  DEFAULT_CHASSIS_MATRIX,
  getChassisCompatibility,
  type ChassisCompatibilityMatrix,
} from '../services/chassisCompatibility.service';

/**
 * Returns the size<->chassis compatibility matrix used by
 * `validateChassisCompatibility`.
 *
 * Seeds synchronously from the bundled DEFAULT so save-blocking validation works
 * immediately (and offline / in tests), then hydrates from the canonical backend
 * endpoint — so a backend change to the matrix is picked up without a frontend
 * redeploy. On fetch failure it simply stays on the bundled default.
 */
export function useChassisCompatibility(): ChassisCompatibilityMatrix {
  const [matrix, setMatrix] = useState<ChassisCompatibilityMatrix>(DEFAULT_CHASSIS_MATRIX);

  useEffect(() => {
    let alive = true;
    getChassisCompatibility()
      .then((m) => {
        if (alive) setMatrix(m);
      })
      .catch(() => {
        /* keep the bundled default */
      });
    return () => {
      alive = false;
    };
  }, []);

  return matrix;
}
